// @ts-nocheck
/* eslint-disable spire/export-styles */
import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";

/* Starter Custom Code - Start */
import translate from "@insite/client-framework/Translate";
/* Starter Custom Code - End */

interface OwnProps {
    title: string;
    userId: string;
}

type Props = OwnProps;

const UserSetupPageTypeLink: React.FunctionComponent<Props> = ({ title, userId }) => {
    return createWidgetElement("Basic/PageTypeLink", {
        fields: {
            pageType: "UserSetupPage",
            overrideTitle: title,
            queryString: `userId=${userId}`,
            linkAccessibleText: translate("See User Details"), // Starter Custom Code
        },
    });
};

export default UserSetupPageTypeLink;
